import {createAction, props} from "@ngrx/store";

export const resetError = createAction(
    '[Error] reset error',
);
export const setError = createAction(
    '[Error] set an Error',
    props<{ title?: string, message: string, details?: string, redirectTo500Page: boolean }>(),
);
